import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { DeviceType } from '~/types/device-type'

import MwMLogo from '~/assets/mwm-owner-logo.png'
import AppLogo from '~/components/AppLogo'

import './styles.scss'

const ApplicationCellRenderer = ({
  value,
}: ICellRendererParams<
  unknown,
  {
    app_icon_url: string
    device_type: DeviceType
    name?: string
    publisher_name?: string
  }
>): ReactElement => {
  const { app_icon_url, device_type, name, publisher_name } = value || {}

  return (
    <div className="application-cell-renderer-container">
      <AppLogo
        appLogoUrl={app_icon_url}
        appPlatform={device_type}
        className="application-cell-renderer-container__logo"
        size="small"
      />
      {name ? (
        <div className="application-name-container">
          <span className="application-name">{name}</span>
        </div>
      ) : null}
      {publisher_name && publisher_name.includes('MWM') ? (
        <img alt="App logo" className="logo-app-owner" src={MwMLogo} />
      ) : null}
    </div>
  )
}

export default ApplicationCellRenderer
